import Config from './notifications.router';
import options from './notifications.component';

require('./all-notifications.png'); // eslint-disable-line

const Component = {
    selector: 'dtNotifications',
    options
};

export {
    Config,
    Component
};



// WEBPACK FOOTER //
// ./app/components/notifications/index.js